import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";

import TutorialVideo from "../images/tutorialvideo.svg";
import Discussoion from "../images/Discussion_forum.svg";
import PractiseQuize from "../images/Practise_quizz.svg";
import Learning from "../images/Learning_Material.svg";
import Guidence from "../images/Guidences.svg";

export default function WhatDoYouGet() {
    const [isMobile, setIsMobile] = useState(false);


    console.log("isMobile", isMobile)

    useEffect(() => {
        const checkWidth = () => setIsMobile(window.innerWidth < 768);
        checkWidth();
        window.addEventListener("resize", checkWidth);
        return () => window.removeEventListener("resize", checkWidth);
    }, []);

    const items = [
        {
            img: TutorialVideo,
            title: "Driving Tutorial Videos",
            desc: "Watch engaging and informative videos to learn various driving techniques and road safety rules.",
        },
        {
            img: Discussoion,
            title: "Driver Discussion Forum",
            desc: "Join online discussion forums to exchange driving tips, share experiences, and get guidance from experts.",
        },
        {
            img: PractiseQuize,
            title: "Driving Practice & Quizzes",
            desc: "Test your knowledge with interactive driving exercises and quizzes to enhance your skills.",
        },
        {
            img: Learning,
            title: "Driving Learning Materials",
            desc: "Access comprehensive driving resources, including manuals, road signs, safety guidelines, and a glossary.",
        },
        {
            img: Guidence,
            title: "Expert Guidance from Driving Instructors",
            desc: "Our team of experienced and professional driving instructors is here to answer your questions and provide the guidance you need to become a confident driver.",
        },
    ];

    return (
        <section className="what_do_you_get">
            <div className="container">
                <div className="row justify-content-between">
                    <div className="col-md-5 col-lg-4 mb-3 mb-md-0">
                        <h4>
                            What do you get at <span>Confident Driver?</span>
                        </h4>
                    </div>
                    <div className="col-md-6 col-lg-6">
                        <p className="w-100">
                            Confident Driver is an online learning platform specifically
                            designed to help you learn driving easily, enjoyably, and
                            effectively...
                        </p>
                    </div>
                </div>

                {/* Mobile Swiper */}
                {isMobile ? (
                    <Swiper
                        modules={[Navigation]}
                        spaceBetween={20}
                        slidesPerView={1}
                        navigation
                        className="mt-4"
                    >
                        {items.map((item, index) => (
                            <SwiperSlide key={index}>
                                <div className="box box-2">
                                    <img src={item.img} alt={item.title} />
                                    <div>
                                        <h5>{item.title}</h5>
                                        <p>{item.desc}</p>
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                ) : (
                    // Desktop Grid
                    <div className="row mt-3 mt-md-5">
                        {items.map((item, index) => (
                            <div
                                key={index}
                                className={`col-sm-${index % 2 === 0 ? "5" : "7"} col-lg-${index === 4 ? "6" : index % 2 === 0 ? "3" : "6"
                                    } mb-4`}
                            >
                                <div className={`box ${index % 2 === 0 ? "box-3" : "box-2"}`}>
                                    <img src={item.img} alt={item.title} />
                                    <div>
                                        <h5>{item.title}</h5>
                                        <p>{item.desc}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </section>
    );
}
